import { CustomerAddSelect, CustomerForm, DrawerCloseButton } from '@components';
import { L } from '@lib';
import { CreateCustomer, Customer, InitialCustomer } from '@services';
import { Alert, Button, Drawer, FormInstance, Space, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

export const ASSIGN_CUSTOMER_FORM_ID = 'invoice-assign-customer-form';

interface IProps {
  open: boolean;
  isMobile: boolean;
  loading: boolean;
  showCustomerForm: boolean;
  customerForm: FormInstance<CreateCustomer>;
  selectedCustomer: Customer | null;
  onClose: () => void;
  onSelect: (id: string) => void;
  onClearSelection: () => void;
  onAddClick: () => void;
  onCancelForm: () => void;
  onAddressSearch: (value: string) => void;
  onCreate: (values: CreateCustomer) => Promise<void>;
  onAssign: () => void;
}

const SelectedCustomerSummary: React.FC<{ customer: Customer }> = ({ customer }) => (
  <Space direction="vertical" size={0}>
    <Text strong>{customer.fullname}</Text>
    {customer.email && <Text type="secondary">{customer.email}</Text>}
    {customer.phone && <Text type="secondary">{customer.phone}</Text>}
  </Space>
);

export const InvoiceAssignCustomerDrawerPresentation: React.FC<IProps> = ({
  open,
  isMobile,
  loading,
  showCustomerForm,
  customerForm,
  selectedCustomer,
  onClose,
  onSelect,
  onClearSelection,
  onAddClick,
  onCancelForm,
  onAddressSearch,
  onCreate,
  onAssign,
}) => (
  <Drawer
    title={L('Assign customer')}
    open={open}
    onClose={onClose}
    styles={{ wrapper: { width: isMobile ? '100%' : 720 } }}
    destroyOnHidden
    closable={false}
    extra={<DrawerCloseButton onClick={onClose} />}
    footer={
      <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={showCustomerForm ? onCancelForm : onClose} disabled={loading}>
          {L('Cancel')}
        </Button>
        {showCustomerForm ? (
          <Button type="primary" htmlType="submit" form={ASSIGN_CUSTOMER_FORM_ID} loading={loading}>
            {L('Create and assign')}
          </Button>
        ) : (
          <Button type="primary" onClick={onAssign} disabled={!selectedCustomer} loading={loading}>
            {L('Assign')}
          </Button>
        )}
      </Space>
    }
  >
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Alert
        type="info"
        showIcon
        message={L(
          'This sale was recorded against the walk-in customer. Only this invoice moves to the customer you choose.'
        )}
      />
      {showCustomerForm ? (
        <CustomerForm
          id={ASSIGN_CUSTOMER_FORM_ID}
          hideButtons
          form={customerForm}
          initialValues={InitialCustomer}
          onFinish={onCreate}
          onCancel={onCancelForm}
          handleAddressSearch={onAddressSearch}
        />
      ) : (
        <>
          <CustomerAddSelect
            showAddButton
            onSelect={onSelect}
            onDeselect={onClearSelection}
            onClear={onClearSelection}
            onAddClick={onAddClick}
          />
          {selectedCustomer && <SelectedCustomerSummary customer={selectedCustomer} />}
        </>
      )}
    </Space>
  </Drawer>
);
